{
    "especial": {
        "titulo": "Vorschlag / Beratung",
        "conf_consulta": "Hallo! Vielen Dank für Ihren Vorschlag/Ihre Anfrage. Die Ethikkommission wird Ihren Vorschlag prüfen. Wir werden Sie über den Fortgang des Falles sowie über die endgültige Entscheidung auf dem Laufenden halten!"
    },
    "actions": {
        "close": "Schließen",
        "send": "Senden",
        "toattach": "Dokumentation / Beweis",
        "save": "Speichern",
        "clean": "Leeren",
        "singin": "Anmelden",
        "restore": "Wiederherstellen",
        "return": "Zurück",
        "confirm": "Akzeptieren",
        "cancel": "Abbrechen",
        "access": "Zugang",
        "create": "Erstellen",
        "cerrarFase": "Phase abschließen",
        "listen": "Anhören"
    },
    "forms": {
        "title": "Was möchten Sie tun?",
        "fraseinicial": "SEHR WICHTIG: Wenn die Beschwerde den Verwalter der Gesellschaft oder eines der Mitglieder des Ethikkomitees betrifft, benutzen Sie bitte immer das anonyme Beschwerdeformular. Zusätzlich können Sie uns über die üblichen Kontaktwege unserer Organisation kontaktieren, um mehr über unser Ethikkomitee und unser Compliance-System zu erfahren.",
        "subtitle": "Hier können Sie uns über Vorfälle informieren oder Fragen zu Rechtsverstößen, Verstößen gegen unsere Richtlinien und Verfahren oder sonstige Verstöße stellen",
        "subtitle2": "Dies ist kein Notdienst. Im Falle einer unmittelbaren Gefahr wenden Sie sich an die zuständigen Behörden",
        "complaintsChannel": "Beschwerdekanal",
        "consult": "Beratung",
        "anonymous": "Anonym",
        "nominal": "Nominell",
        "voice": "Stimme",
        "voice_record": "Aufnahme starten",
        "voice_stop": "Aufnahme stoppen",
        "voice_recording ": "Aufnahme läuft...",
        "voice_recorded ": "Aufnahme abgeschlossen",
        "voice_instructions": "<strong>Hinweis:</strong> Die Stimme wird nicht verzerrt.",
        "voice_error": "Fehler beim Zugriff auf das Mikrofon. Bitte stellen Sie sicher, dass Sie die erforderlichen Berechtigungen erteilt haben und dass Ihr Gerät über ein funktionierendes Mikrofon verfügt.",
        "complaint": "Beschwerde",
        "finalMesssage": "Sie können den Status über die URL abfragen: ",
        "finalMesssage2": "Indem Sie den folgenden Code eingeben: ",
        "finalMessage3": "Sie können eine Kopie drucken oder als PDF speichern, indem Sie ",
        "finalDenuncia": "Wenn Sie den Fortschritt der Beschwerde verfolgen möchten, sollten Sie den Link und den auf dem Bildschirm angezeigten Code speichern.",
        "finalDenuncia2": "Wir empfehlen Ihnen, regelmäßig auf Ihre Beschwerde zuzugreifen, um zu prüfen, ob wir Kontakt mit Ihnen aufgenommen haben.",
        "typeChannel": "Was möchten Sie tun?",
        "typeComplaint": "Art der Beschwerde",
        "answer": "Antwort",
        "email": "E-mail",
        "name": "Name",
        "user": "Benutzer",
        "password": "Passwort",
        "privacity": "Ich habe gelesen und akzeptiere die ",
        "privacity2": "Ich habe gelesen ",
        "capa1_GEN": "Behandlungsmanager: ",
        "capa2_GEN": ". Zweck: Überwachung, Verwaltung und Lösung der über den ethischen Kanal eingegangenen Anfrage. Ausübung Ihrer Rechte und weitere Informationen zur Datenverarbeitung:",
        "capa1_1": "Gemäß den Datenschutzbestimmungen stellen wir Ihnen die folgenden Informationen zur Verarbeitung zur Verfügung:",
        "capa1_2": "Verantwortlich: HEALTH TIME, S.L. (NACHFOLGEND HT MEDICA).",
        "capa1_3": "Zweck der Verarbeitung: angemessene Verwaltung unseres ethischen Kanals, Bearbeitung der über diesen Kanal gemeldeten Unregelmäßigkeiten",
        "capa1_4": "Ihre Rechte: Zugang, Berichtigung, Übertragbarkeit, Löschung, Einschränkung und Widerspruch",
        "capa1_5": "Weitere Informationen zur Verarbeitung finden Sie in unserer Datenschutzrichtlinie",
        "capa1_6": "Ihre Zustimmung ist für die weitere Verarbeitung dieser Daten im Verfahren erforderlich und ohne diese wäre die Bearbeitung Ihrer Anfrage nicht möglich.",
        "anonimato": "Um die Anonymität zu wahren, wird empfohlen, nur Dateien im PDF-Format hochzuladen ",
        "policy": "Datenschutzrichtlinie",
        "consultation": {
            "name": "Name",
            "surname": "Nachname",
            "phone": "Telefon",
            "email": "E-mail",
            "ordinario": "Adresse",
            "otromedia": "Ein anderes Kommunikationsmittel?",
            "anompo": "Anonymisiert durch ",
            "mediocom": "Kommunikationsmittel",
            "otros": "Andere",
            "organization": "Zugehörige Organisation",
            "relationship": "Welche Beziehung haben Sie?",
            "message": "Was ist Ihre Anfrage/Beschwerde?",
            "nature": "Art der Anfrage/Beschwerde",
            "notificacionMensaje": "Benachrichtigungen erhalten durch ",
            "bloquear": "Ist der Kanalverantwortliche (Compliance Officer) oder das Leitungsgremium an den gemeldeten Vorfällen beteiligt? ",
            "bloqueoOrgano": "Ja, das Leitungsgremium (wird keine Benachrichtigung über die Beschwerde erhalten)",
            "bloqueoOffice": "Ja, der Compliance Officer (wird keine Benachrichtigung über die Beschwerde erhalten)",
            "bloquearEsp": "Ist der Kanalverantwortliche  oder das Leitungsgremium an den gemeldeten Vorfällen beteiligt? ",
            "bloqueoOrganoEsp": "Ja, das Leitungsgremium (wird keine Benachrichtigung über die Beschwerde erhalten)",
            "bloqueoOfficeEsp": "Ja, der Kanalverantwortliche (wird keine Benachrichtigung über die Beschwerde erhalten)",
            "defajenos": "Ihre Beschwerde wird anonymisiert, da sie personenbezogene Daten enthält, die nicht relevant für die gemeldeten Vorfälle sind. Bitte reichen Sie die Beschwerde erneut ein, ohne diese Daten zu enthalten.",
            "defsensibles": "Ihre Beschwerde wird anonymisiert, da sie personenbezogene Daten aus speziellen Datenkategorien enthält. Bitte reichen Sie die Beschwerde erneut ein, ohne diese Daten zu enthalten."
        },
        "comp": {
            "whatComp": "Was ist Ihre Beschwerde?",
            "involved": "Beteiligte Person/en",
            "involved2": "Wenn Sie die Identität der beteiligten Person/en nicht kennen, schreiben Sie `Ich weiß es nicht`",
            "department": "Betroffene Abteilung",
            "headquarters": "Betroffene Zentrale",
            "otherComplaints": "Beschreibung der Beschwerde",
            "other": "Détaillez d'autres délits",
            "nature": "Art der Beschwerde",
            "when": "Wann ist der Vorfall passiert?",
            "reiterativo": "Wiederholt sich der Vorfall?",
            "yes": "Ja",
            "no": "Nein",
            "bloqmiembro": "Mitglied blockieren"
        },
        "principalBreadCrumb": "Anfrage oder Beschwerde",
        "profile": "Profil anzeigen",
        "settings": "Einstellungen",
        "contact": "Kontakt",
        "signout": "Abmelden",
        "imgText": "Ziehen Sie die Dokumente per Drag-and-Drop hierher oder klicken Sie hier"
    },
    "login": {
        "user": "Benutzername",
        "password": "Passwort",
        "forgot": "Haben Sie Ihr Passwort vergessen?",
        "title": "Identifikation des Superusers",
        "titleEmp": "Unternehmensidentifikation",
        "titleUser": "Benutzeridentifikation",
        "restore": "Wiederherstellen",
        "titleRestore": "Passwort wiederherstellen",
        "finalMesssage": "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
        "restoreFail": "Une erreur s'est produite, veuillez réessayer.",
        "email": "E-Mail",
        "errorUsu": "Der Benutzer ist gesperrt, bitte wenden Sie sich an einen Administrator, um ihn freizuschalten",
        "errorBlock": "L'utilisateur est bloqué, veuillez contacter un administrateur pour le débloquer",
        "restoreFailEmail": "Das Format der E-Mail ist nicht gültig"
    },
    "error": {
        "name": "Name ist ein Pflichtfeld",
        "user": "Benutzer ist ein Pflichtfeld"
    },
    "menu": {
        "complaintsChannel": "Beschwerdekanal",
        "mcompany": "UNTERNEHMEN ERSTELLEN",
        "msuperuser": "SUPERBENUTZER ERSTELLEN",
        "roleMain": "ROLLENVERWALTUNG",
        "countryMain": "LANDVERWALTUNG",
        "offenseMain": "VERWALTUNG VON DELIKTEN",
        "mainLanguages": "SPRACHVERWALTUNG",
        "fontMain": "SCHRIFTARTENVERWALTUNG",
        "relation": "BEZIEHUNGSVERWALTUNG",
        "nature": "ART DE VERWALTUNG",
        "headquarters": "VERWALTUNG VON HAUPTSITZEN",
        "departments": "ABTEILUNGSVERWALTUNG",
        "users": "BENUTZERVERWALTUNG",
        "mydata": "MEINE DATEN",
        "statistics": "STATISTIKEN",
        "whistleblower": "INFORMANT",
        "history": "FALLVERLAUF",
        "ocases": "OFFENE FÄLLE",
        "title": "Hallo",
        "mylinks": "MEINE LINKS",
        "notice": "MEINE MITTEILUNGEN",
        "noticemin": "Meine Mitteilungen",
        "searcher": "SUCHFUNKTION",
        "config": "EINSTELLUNGEN",
        "changep": "PASSWORT ÄNDERN"
    },
    "maintenance": {
        "actions": {
            "add": "Hinzufügen",
            "cancel": "Abbrechen",
            "confirm": "Akzeptieren"
        },
        "languages": {
            "title": "Sprachverwaltung",
            "name": "Name",
            "key": "Code",
            "deleteTitle": "Löschen der Sprache {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie die Sprache löschen möchten?",
            "deleteConfirm": "Die Sprache wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Sprache bearbeiten {name}",
            "editMessage": "Die Sprache wurde bearbeitet",
            "addTitle": "Neue Sprache hinzufügen"
        },
        "countries": {
            "title": "Länderverwaltung",
            "name": "Name",
            "id": "Code",
            "deleteTitle": "Land löschen {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie das Land löschen möchten?",
            "deleteConfirmTitle": "Das Land wurde gelöscht",
            "deleteConfirm": "Das Land wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Land bearbeiten {name}",
            "editMessage": "Das Land wurde bearbeitet",
            "addTitle": "Neues Land hinzufügen"
        },
        "natures": {
            "title": "Naturverwaltung",
            "name": "Name",
            "deleteTitle": "Natur löschen {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie die Natur löschen möchten?",
            "deleteConfirmTitle": "Die Natur wurde gelöscht",
            "deleteConfirm": "Die Natur wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Natur bearbeiten {name}",
            "editMessage": "Die Natur wurde bearbeitet",
            "addTitle": "Neue Natur hinzufügen"
        },
        "relations": {
            "title": "Beziehungsverwaltung",
            "name": "Name",
            "deleteTitle": "Beziehung löschen {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie die Beziehung löschen möchten?",
            "deleteConfirmTitle": "Die Beziehung wurde gelöscht",
            "deleteConfirm": "Die Beziehung wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Beziehung bearbeiten {name}",
            "editMessage": "Die Beziehung wurde bearbeitet",
            "addTitle": "Neue Beziehung hinzufügen"
        },
        "superusers": {
            "title": "Superbenutzer",
            "name": "Name",
            "id": "Code",
            "email": "E-mail",
            "password": "Passwort",
            "state": "Status",
            "deleteTitle": "Super-Benutzer löschen {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie den Super-Benutzer löschen möchten?",
            "deleteConfirmTitle": "Der Super-Benutzer wurde gelöscht",
            "deleteConfirm": "Der Super-Benutzer wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Super-Benutzer bearbeiten {name}",
            "editMessage": "Der Super-Benutzer wurde bearbeitet",
            "addTitle": "Neuen Super-Benutzer hinzufügen",
            "lock": "Sperren"
        },
        "companies": {
            "title": "Unternehmen",
            "name": "Name",
            "cif": "Steueridentifikationsnummer",
            "email": "E-mail",
            "password": "Passwort",
            "direction": "Richtung",
            "population": "Bevölkerung",
            "cp": "Postleitzahl",
            "user": "Benutzer",
            "province": "Provinz",
            "group": "Zu welcher Gruppe gehört es?",
            "logo": "Logo",
            "designType": "Design-Typ",
            "companyType": "Unternehmensart",
            "lang": "Sprache",
            "state": "Status",
            "single": "Einzel",
            "iGroup": "Ist es eine Gruppe?",
            "belongs": "Gehört",
            "country": "Land",
            "isGroup": "Gehört es zu einer Gruppe?",
            "is-group": "Gruppe?",
            "deleteTitle": "Unternehmen löschen {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie das Unternehmen löschen möchten?",
            "deleteConfirmTitle": "Das Unternehmen wurde gelöscht",
            "deleteConfirm": "Das Unternehmen wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Unternehmen bearbeiten {name}",
            "editMessage": "Das Unternehmen wurde bearbeitet",
            "addTitle": "Neues Unternehmen hinzufügen",
            "imgText": "Ziehen Sie das Bild hierher oder klicken Sie hier",
            "unlock": "Entsperren",
            "lock": "Sperren",
            "link": "Link zum Beschwerdekanal:",
            "typeRed": "Rote Art",
            "typeBlue": "Blaue Art",
            "typeGreen": "Grüne Art",
            "typeOrange": "Orange Art"
        },
        "fonts": {
            "title": "Wartung der Schriften",
            "name": "Name",
            "deleteTitle": "Löschen der Beziehung {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie die Schrift löschen möchten?",
            "deleteConfirmTitle": "Die Schrift wurde gelöscht",
            "deleteConfirm": "Die Schrift wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Bearbeitung der Schrift {name}",
            "editMessage": "Die Schrift wurde bearbeitet",
            "addTitle": "Neue Schrift hinzufügen"
        }
    },
    "mCompany": {
        "users": {
            "title": "Wartung der Benutzer",
            "name": "Name",
            "password": "Passwort",
            "email": "E-mail",
            "dni": "Personalausweisnummer",
            "user": "Benutzer",
            "governingBody": "Leitungsorgan",
            "compliance": "Compliance Officer",
            "rol": "Wählen Sie eine Rolle",
            "rolTable": "Rolle",
            "deleteTitle": "Löschen des Benutzers {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie den Benutzer löschen möchten?",
            "deleteConfirmTitle": "Der Benutzer wurde gelöscht",
            "deleteConfirm": "Der Benutzer wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Bearbeiten des Benutzers {name}",
            "editMessage": "Der Benutzer wurde bearbeitet",
            "addTitle": "Neuen Benutzer hinzufügen",
            "state": "Status",
            "signature": "Hat eine digitale Unterschrift?"
        },
        "departments": {
            "title": "Wartung der Abteilungen",
            "name": "Name",
            "deleteTitle": "Löschen des Abteilung {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie die Abteilung löschen möchten?",
            "deleteConfirmTitle": "Der Abteilung wurde gelöscht",
            "deleteConfirm": "Der Abteilung wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Bearbeitung des Abteilung {name}",
            "editMessage": "Der Abteilung wurde bearbeitet",
            "addTitle": "Neuen Abteilung hinzufügen"
        },
        "headquarters": {
            "title": "Wartung der Standorte",
            "name": "Name",
            "deleteTitle": "Löschen des Standorts {name}",
            "deleteMessage": "Sind Sie sicher, dass Sie den Standort löschen möchten?",
            "deleteConfirmTitle": "Der Standort wurde gelöscht",
            "deleteConfirm": "Der Standort wurde gelöscht",
            "deleteError": "Es gab einen Fehler beim Löschen",
            "editTitle": "Bearbeitung des Standorts {name}",
            "editMessage": "Der Standort wurde bearbeitet",
            "addTitle": "Neuen Standort hinzufügen"
        },
        "mylink": {
            "title": "Meine Links",
            "linkForms": "Links zu Formularen",
            "linkUser": "Links zum Benutzerlogin",
            "linkWhistleblower": "Link zum Status Ihrer Anfrage"
        },
        "statistic": {
            "title": "Meine Statistiken"
        }
    },
    "mUser": {
        "mydata": {
            "title": "Meine Daten"
        },
        "chistory": {
            "title": "Fallverlauf",
            "titleAnalysis": "Fallverlauf > Analyse",
            "titleDecision": "Fallverlauf > Entscheidung",
            "titleComunication": "Fallverlauf > Kommunikation",
            "date": "Datum",
            "type": "Typ",
            "user": "Geschlossen von",
            "code": "Code",
            "governingBody": "Leitungsorgan",
            "compliance": "Compliance Officer",
            "consult": "Anfrage",
            "anonymous": "Anonym",
            "nominal": "Nominal",
            "case": "FALL",
            "seecomunication": "Informant"
        },
        "ocases": {
            "title": "Offene Fälle",
            "time": "BEGRIFF",
            "intime": "RECHTZEITIG",
            "outtime": "AUS DER ZEIT",
            "titleAnalysis": "Offene Fälle > Analyse",
            "titleDecision": "Offene Fälle > Entscheidung",
            "titleComunication": "Offene Fälle > Kommunikation",
            "date": "Datum",
            "type": "Typ",
            "question": "Frage",
            "answer": "Antwort",
            "nature": "Natur",
            "phase": "Phase",
            "user": "Zugewiesen an",
            "code": "Code",
            "governingBody": "Leitungsorgan",
            "compliance": "Compliance Officer",
            "consult": "Anfrage",
            "anonymous": "Anonym",
            "nominal": "Nominal",
            "danonymous": "Anonyme Anzeige",
            "dnominal": "Nominale Anzeige",
            "isCrime": "Gibt es ein Verbrechen, das mit der Anfrage/Anzeige in Verbindung steht?",
            "crimes": "Geben Sie die zugehörigen Verbrechen ein",
            "investigation": "Ermittlungen",
            "author": "Autor",
            "uploadFile": "Vom Hinweisgeber hochgeladene Dateien",
            "files": {
                "name": "Name",
                "date": "Datum",
                "download": "Herunterladen"
            },
            "authors": {
                "name": "Name",
                "date": "Datum"
            },
            "close": "Anfrage schließen",
            "closedenu": "Phase schließen",
            "invPhase": {
                "title": "Ermittlungsphase",
                "text": "Antwort",
                "cause": "Analyse der Ursachen",
                "observation": "Beobachtungen",
                "relevant": "Ist es relevant?",
                "conclusionPhase2": "Endgültiger Schluss",
                "yes": "Ja",
                "no": "Nein"
            },
            "falsa": "Falsche Anzeige",
            "avisoFAS": "Wenn Sie auf die Sendeschaltfläche klicken, wird die Anzeige beendet",
            "ajenos": "Persönliche Daten von Dritten",
            "sensibles": "Empfindliche Daten",
            "anadirusuario": "Benutzer zur Ermittlung hinzufügen",
            "asistenteia": "KI-Assistent",
            "newPregunta": "Neue Frage",
            "falseMensaje": "Werden rechtliche Schritte eingeleitet?",
            "exportCase": "Fall exportieren",
            "caseType": "Falltyp: ",
            "create": "ERSTELLT",
            "analysis": "ANALYSE",
            "decision": "ENTSCHEIDUNG",
            "comunication": "KOMMUNIKATION",
            "finished": "ABGESCHLOSSEN",
            "deleteTitle": "Datei löschen",
            "deleteMessage": "Sind Sie sicher, dass Sie die Datei löschen möchten?",
            "relevant": "Ist es relevant?",
            "attachFile": "Angehängte Datei :",
            "seephase": "Analyse",
            "high": "HOCH",
            "medio": "MITTEL",
            "low": "NIEDRIG",
            "priorityComplaint": "Beschwerdepriorität",
            "activateFiles": "Dateiupload für den Beschwerdeführer aktivieren",
            "activateMessages": "Nachrichtenbereich für den Beschwerdeführer aktivieren",
            "mensajeConfirmacion": "Sind Sie sicher, dass Sie die Phase abschließen möchten? Es gibt kein Zurück",
            "phase3": {
                "title": "FALL ",
                "final": "Endgültige Entscheidung",
                "people": "Entscheidungen über betroffene Personen",
                "compliance": "Entscheidungen über das Compliance-System",
                "organization": "Entscheidungen über die Arbeitsabläufe der Organisation",
                "compliant": "Entscheidungen über andere interessierte Parteien, die in die Beschwerde verwickelt sind",
                "comunication": "Entscheidungen über die Kommunikation",
                "other": "Andere Entscheidungen",
                "observation": "Beobachtungen",
                "save": "Speichern",
                "close": "Schließen",
                "btnpeople": "Betroffene Personen",
                "btncompliance": "Compliance-System",
                "btnorganization": "Arbeit der Organisation",
                "btncompliant": "Andere interessierte Parteien",
                "btncomunication": "Kommunikation",
                "btnother": "Andere",
                "message": "Der Text der Anfrage/Beschwerde lautet : ",
                "messagedenu": "Der Text der Anfrage/Beschwerde lautet : ",
                "seephase": "Entscheidung",
                "return": "Zurück",
                "cause": "Phase Ursachen",
                "observationphase2": "Beobachtung der Phase",
                "relevant": "Ist relevant",
                "conclusionPhase2": "Phase Abschluss",
                "nodecision": "Die Beschwerde hat keine Entscheidungen",
                "decisionfinal": "Endgültige Entscheidung"
            },
            "phase4": {
                "title": "FALL ",
                "people": "Mitteilungen an betroffene Personen",
                "responsible": "Mitteilungen an die Verantwortlichen für die betroffenen Personen",
                "organization": "Mitteilung an den Rest der Organisation",
                "compliant": "Mitteilung an den Beschwerdeführer",
                "adminpublic": "Mitteilung an die öffentliche Verwaltung",
                "other": "Mitteilung an andere interessierte Parteien",
                "observation": "Beobachtungen",
                "save": "Speichern",
                "close": "Schließen",
                "btnpeople": "Betroffene Personen",
                "btnresponsible": "Verantwortliche",
                "btnorganization": "Rest der Organisation",
                "btncompliant": "Beschwerdeführer",
                "btnadminpublic": "Öffentliche Verwaltung",
                "btnother": "Andere",
                "message": "Der Text der Anfrage/Beschwerde lautet : ",
                "messagedenu": "Der Text der Anfrage/Beschwerde lautet : ",
                "seephase": "Kommunikation",
                "return": "Zurück",
                "cause": "Phase Ursachen",
                "observationphase2": "Beobachtung der Phase",
                "relevant": "Ist es relevant",
                "conclusionPhase2": "Phase Abschluss",
                "channel": "Kanal / verwendetes Kommunikationsmittel",
                "email": "E-mail",
                "phone": "Telefon",
                "presencial": "Vor Ort",
                "otherchannel": "Andere",
                "nocomunication": "Die Beschwerde hat keine Kommunikationen",
                "resolucion": "Informationen zur Auflösung für den Beschwerdeführer",
                "ultentrada": "Letzter Zugriff"
            },
            "messages": {
                "date": "Datum",
                "text": "Nachricht",
                "title": "Nachrichten"
            },
            "filesUsu": {
                "title": "Dateien des Beschwerdeführers"
            },
            "InviUsu": {
                "title": "Hinzugefügte Benutzer",
                "name": "Name",
                "motivo": "Grund"
            }
        }
    },
    "mwhistleblower": {
        "title": "Beschwerdeführer",
        "case": "FALL - ",
        "uploadFile": "Dateien hochladen",
        "message": "Nachrichten",
        "state": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : ",
        "finished": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : ABGESCHLOSSEN",
        "comunication": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : KOMMUNIKATION",
        "decision": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : ENTSCHEIDUNG",
        "analysis": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : IN BEARBEITUNG",
        "created": "AKTUELLER STATUS DER BESCHWERDE/ANFRAGE : ERSTELLT",
        "messagetext": "Schreiben Sie hier Ihre Nachricht...",
        "messageTitle": "Nachricht"
    },
    "phases": {
        "actions": {
            "close": "Fall schließen",
            "save": "Speichern",
            "addFile": "Neue Datei anhängen",
            "seeFiles": "Dateiverlauf ansehen",
            "seePDF": "PDF-Verlauf ansehen"

        },
        "id": "ID",
        "date": "Datum",
        "type": "Typ",
        "state": "Status",
        "lastUser": "Letzter Benutzer",
        "commentary": "Kommentar"
    },
    "statistics": {
        "title": "FILTER",
        "date_ini": "Startdatum",
        "date_fin": "Enddatum",
        "type": "Typ",
        "relation": "Beziehung",
        "font": "Quelle",
        "nature": "Natur",
        "priority": "Priorität",
        "appropriate": "Angemessen",
        "msede": "Standort",
        "mdepa": "Abteilung",
        "state": "Status",
        "create": "Erstellt",
        "analysis": "Analyse",
        "decision": "Entscheidung",
        "fin": "Abgeschlossen",
        "consulta": "Anfrage",
        "anonimo": "Anonym",
        "nominal": "Nominell",
        "Tcreate": "ERSTELLT",
        "Tanalysis": "ANALYSE",
        "Tdecision": "ENTSCHEIDUNG",
        "Tcomunicacion": "KOMMUNIKATION",
        "Tfin": "ABGESCHLOSSEN",
        "nomfont": "QUELLENNAME",
        "numfont": "GESAMT",
        "total": "Gesamte Beschwerden",
        "ptotal": "Prozentsatz gesamt",
        "filter": "Gefiltert",
        "pfilter": "Prozentsatz gefiltert",
        "resume": "ZUSAMMENFASSUNG",
        "pstate": "NACH STATUS",
        "pfuente": "NACH QUELLE",
        "department": "ABTEILUNG",
        "sede": "STANDORT",
        "listdenu": "DETAIL",
        "date": "Datum"
    },
    "search": {
        "title": "Suche nach Beschwerden/Anfragen nach Code",
        "search": "Suchen",
        "code": "Code",
        "whistleblower": "Hinweisgeber"
    },
    "errors": {
        "0": "Daten erfolgreich gespeichert",
        "1": "Ein Fehler ist aufgetreten.",
        "1.1": "Überprüfen Sie die Formulardaten",
        "2": "Der Eintrag existiert bereits",
        "3": "Es existieren keine Einträge",
        "4": "Benutzer entsperrt",
        "8": "Benutzer gesperrt",
        "5": "Unternehmen entsperrt",
        "9": "Unternehmen gesperrt",
        "6": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
        "7": "Sie müssen ein Zertifikat auswählen, um den Fall zu schließen",
        "title": "Hinweis",
        "fieldOb": "Sie müssen alle Pflichtfelder (*) ausfüllen und die Datenschutzrichtlinie akzeptieren",
        "comment": "Felder mit * sind Pflichtfelder",
        "comment2": "Alle mit einem Sternchen (*) gekennzeichneten Felder sind Pflichtfelder.",
        "acuse": "Empfangsbestätigung",
        "errorEmail": "Das E-Mail-Format ist ungültig"
    },
    "export": {
        "title": "Exportieren",
        "case": "Fall",
        "name": "Name: ",
        "surname": "Nachname: ",
        "email": "E-mail: ",
        "phone": "Telefon: ",
        "relation": "Beziehung: ",
        "organization": "Organisation: ",
        "nature": "Natur: ",
        "offense": "Straftat: ",
        "consultation": "Anfrage: ",
        "type": "Typ: ",
        "department": "Abteilung: ",
        "priority": "Priorität: ",
        "headquarters": "Hauptsitz: "
    },
    "configuration": {
        "email": "E-mail",
        "user": "Benutzer",
        "password": "Passwort",
        "server": "Server",
        "port": "Port",
        "security": "Sicherheit",
        "nosec": "Keine Sicherheit",
        "footer": "RGPD-Rechtstext",
        "save": "Konfiguration speichern",
        "repeatPassword": "Passwort wiederholen",
        "messageError": "Die Passwörter sind unterschiedlich",
        "messageError2": "Das Passwort muss mindestens 8 Zeichen lang sein und mindestens einen Großbuchstaben, einen Kleinbuchstaben, eine Zahl und ein Symbol enthalten.",
        "change": "Speichern",
        "changePassword": "Passwort ändern",
        "newPassword": "Neues Passwort",
        "pprivacity": "URL der Datenschutzrichtlinie"
    },
    "legal": {
        "cookieNotice": "Diese Website verwendet nur eigene technische Cookies und erfasst oder übermittelt keine personenbezogenen Daten der Benutzer ohne deren Kenntnis. Sie enthält jedoch Links zu Websites Dritter mit Datenschutzrichtlinien, die von unserer abweichen. Sie können selbst entscheiden, ob Sie diese akzeptieren möchten, wenn Sie darauf zugreifen. Weitere Informationen finden Sie in unserer Cookie-Richtlinie, klicken Sie ",
        "cookieNoticeRef": "hier",
        "pprivacity": "Datenschutzrichtlinie",
        "legalWarn": "Impressum",
        "pcookies": "Cookie-Richtlinie",
        "asistenteIa": "The information provided by this artificial intelligence is for informational purposes only and should not be interpreted as legal or professional advice of any kind. For specific guidance, it is recommended to consult a qualified professional."
    }
}